import { useState } from 'react';

export const useModal = () => {
  const [show, toggleModal] = useState(false);
  const close = () => toggleModal(false);
  const open = () => toggleModal(true);
  const returnValue: UseModalReturnType = {
    show,
    close,
    open,
  };
  return returnValue;
};
export type UseModalReturnType = {
  show: boolean;
  close: () => void;
  open: () => void;
};
